import { IToggleProps, Toggle } from '@fluentui/react/lib/Toggle';

export interface IPToggleProps extends IToggleProps {}

export const IPToggle = (props: IPToggleProps) => {
  return <Toggle {...props} />;
};
